module.exports = __webpack_public_path__ + "static/media/dawn-win.8a6fb492.png";